import React from 'react'

export const MovieDetails = () => {
  return (
    <main>MovieDetails</main>
  )
}
